// extracted by mini-css-extract-plugin
export var createdDate = "_ni-1";
export var divider = "_ni-2";
export var headerDivider = "_ni-3";
export var messagesCard = "_ni-0";
export var messagesContainer = "_ni-7";
export var messagesContainerWrapper = "_ni-4";
export var pointerCapturingButtonBoxes = "_ni-a";
export var showLeftPanelButton = "_ni-9";
export var showMoreButton = "_ni-c";
export var showMoreButtonContainer = "_ni-b";
export var summaryTitle = "_ni-6";
export var systemMessageCardWrapper = "_ni-d";
export var topButtons = "_ni-8";
export var withPadding = "_ni-5";